import { BaseButton, type BaseButtonProps } from "./BaseButton";
import styles from './DangerButton.module.scss';

export function DangerButton(props: BaseButtonProps): React.ReactElement {
    const { children, ...restProps } = props;
    
    return <BaseButton {...restProps} className={styles.dangerButton}>
        {children}
    </BaseButton>
}